import {
  HeartHandshake, BarChart3, Clock,
  CircleDollarSign, Building2, FileText
} from 'lucide-react';

const benefits = [
  {
    icon: HeartHandshake,
    title: 'Healthcare Marketing Experts',
    description: 'Our team understands medical terminology and healthcare-specific regulations.',
  },
  {
    icon: BarChart3,
    title: 'Proven Track Record',
    description: 'Trusted by 200+ doctors and clinics with measurable patient growth results.',
  },
  {
    icon: Clock,
    title: 'Time-Saving',
    description: 'Doctors focus on care, while we handle marketing and accounting end-to-end.',
  },
  {
    icon: CircleDollarSign,
    title: 'Value for Money',
    description: 'Affordable packages with clear ROI. No hidden costs, no surprises.',
  },
  {
    icon: Building2,
    title: 'Scalable for All Clinics',
    description: 'Works for solo practices, multi-doctor clinics, and hospital chains.',
  },
  {
    icon: FileText,
    title: 'Transparent Reporting',
    description: 'Monthly performance reports with actionable insights and growth strategies.',
  },
];

const WhyChooseUs = () => (
  <section className="bg-[#EDE7D9] py-20 lg:py-28" data-testid="why-choose-us-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-4">Why Emplozera Studio</p>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#11181C] mb-6">
            Proven Systems, Not Experiments
          </h2>
          <p className="text-base leading-relaxed text-[#4A5568] mb-8">
            Just like doctors follow medical systems for reliable care, we follow marketing systems
            to deliver patients — not empty promises. Our all-in-one approach saves you time, money,
            and the hassle of managing multiple vendors — wherever you practice in the world.
          </p>
          <img
            src="https://images.pexels.com/photos/5452190/pexels-photo-5452190.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Doctors discussing partnership"
            className="rounded-2xl w-full h-[280px] object-cover shadow-lg"
            data-testid="why-choose-image"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {benefits.map((b, i) => (
            <div
              key={b.title}
              className="bg-white border border-[#D6CEBF] rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 service-card"
              data-testid={`benefit-${i}`}
            >
              <div className="w-10 h-10 rounded-xl bg-[#D4E4DA] flex items-center justify-center mb-4">
                <b.icon size={20} className="text-[#1B3F33]" />
              </div>
              <h3 className="font-heading text-base font-medium text-[#11181C] mb-2">{b.title}</h3>
              <p className="text-sm text-[#4A5568] leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
